module.exports = __webpack_public_path__ + "static/media/booked.5779b4d4.png";